import React, { useState } from 'react';
import { authApi } from '../../services/api';
import { useAuthStore } from '../../store/authStore';
import toast from 'react-hot-toast';
import './Settings.css';

export default function Settings() {
  const { user, fetchMe } = useAuthStore();
  const [tab, setTab] = useState<'password'|'2fa'|'logs'>('password');
  const [pw, setPw] = useState({ old:'', new:'', confirm:'' });
  const [pwLoading, setPwLoading] = useState(false);
  const [qrCode, setQrCode] = useState('');
  const [otpInput, setOtpInput] = useState('');
  const [tfaStep, setTfaStep] = useState<'idle'|'setup'|'verify'>('idle');
  const [disablePw, setDisablePw] = useState('');
  const [logs, setLogs] = useState<any[]>([]);

  const handlePw = async (e: React.FormEvent) => {
    e.preventDefault(); setPwLoading(true);
    try { await authApi.changePassword({ old_password:pw.old, new_password:pw.new, confirm_password:pw.confirm }); toast.success('Şifrə dəyişdirildi'); setPw({old:'',new:'',confirm:''}); }
    catch (err: any) { toast.error(err.response?.data?.error || 'Xəta'); } finally { setPwLoading(false); }
  };

  const setup2fa = async () => { try { const { data } = await authApi.setup2fa(); setQrCode(data.qr_code); setTfaStep('setup'); } catch { toast.error('Xəta'); } };
  const verify2fa = async () => { try { await authApi.verify2fa(otpInput); toast.success('2FA aktiv edildi'); setTfaStep('idle'); setOtpInput(''); fetchMe(); } catch { toast.error('Yanlış kod'); } };
  const disable2fa = async () => { try { await authApi.disable2fa(disablePw); toast.success('2FA deaktiv edildi'); setDisablePw(''); fetchMe(); } catch { toast.error('Yanlış şifrə'); } };
  const loadLogs = async () => { const { data } = await authApi.loginLogs(); setLogs(data); };

  return (
    <div className="st-page">
      <div className="st-tabs">
        {(['password','2fa','logs'] as const).map(t => (
          <button key={t} className={`st-tab${tab===t?' active':''}`} onClick={() => { setTab(t); if(t==='logs') loadLogs(); }}>
            {t==='password'?'ŞİFRƏ':t==='2fa'?'2FA':'GİRİŞ LOGU'}
          </button>
        ))}
      </div>

      {tab==='password' && (
        <div className="st-card">
          <div className="st-title">ŞİFRƏ DƏYİŞDİR</div>
          <form onSubmit={handlePw} className="st-form">
            {[['old','KÖHNƏ ŞİFRƏ'],['new','YENİ ŞİFRƏ'],['confirm','YENİ ŞİFRƏ (TƏKRAR)']].map(([k,l])=>(
              <div key={k} className="st-field"><label>{l}</label><input type="password" value={(pw as any)[k]} onChange={e=>setPw(p=>({...p,[k]:e.target.value}))} required minLength={k==='new'?8:1}/></div>
            ))}
            <button type="submit" className="st-btn" disabled={pwLoading}>{pwLoading?'GÖZLƏYİN...':'DƏYİŞDİR'}</button>
          </form>
        </div>
      )}

      {tab==='2fa' && (
        <div className="st-card">
          <div className="st-title">İKİ MƏRHƏLƏLİ DOĞRULAMA</div>
          <div className="st-tfa-status">Status: <span className={user?.two_factor_enabled?'ok':'off'}>{user?.two_factor_enabled?'✓ AKTİV':'✗ DEAKTİV'}</span></div>
          {!user?.two_factor_enabled && tfaStep==='idle' && <button className="st-btn" onClick={setup2fa}>2FA AKTİV ET</button>}
          {tfaStep==='setup' && <div className="st-tfa"><p>Google Authenticator ilə skan edin:</p><img src={qrCode} alt="QR" className="st-qr"/><button className="st-btn" onClick={()=>setTfaStep('verify')}>DAVAM ET</button></div>}
          {tfaStep==='verify' && <div className="st-tfa"><p>Authenticator kodunu daxil edin:</p><input type="text" value={otpInput} onChange={e=>setOtpInput(e.target.value.replace(/\D/g,'').slice(0,6))} placeholder="000000" className="st-otp"/><button className="st-btn" onClick={verify2fa}>TƏSDİQLƏ</button></div>}
          {user?.two_factor_enabled && <div className="st-tfa"><p>Deaktiv etmək üçün şifrənizi daxil edin:</p><input type="password" value={disablePw} onChange={e=>setDisablePw(e.target.value)} placeholder="Şifrə" className="st-inp"/><button className="st-btn danger" onClick={disable2fa}>2FA SÖNDÜR</button></div>}
        </div>
      )}

      {tab==='logs' && (
        <div className="st-card">
          <div className="st-title">GİRİŞ LOGU</div>
          <div className="st-logs">
            {logs.map((l,i)=>(
              <div key={i} className={`st-log ${l.success?'':'failed'}`}>
                <div className={`st-ldot ${l.success?'ok':'bad'}`}/>
                <div className="st-lbody"><div className="st-lip">{l.ip_address}</div><div className="st-lagent">{l.user_agent}</div></div>
                <div className="st-ltime">{new Date(l.timestamp).toLocaleString('az-AZ')}</div>
              </div>
            ))}
            {!logs.length && <div className="st-empty">Log yoxdur</div>}
          </div>
        </div>
      )}
    </div>
  );
}
